import { DateTime } from 'luxon';
import type { IntlShape } from 'react-intl';
import { formatDate } from '@/helpers/formatting';

export type MembershipStatus =
  | 'active'
  | 'will-inactivate'
  | 'pending-inactivation'
  | 'inactive';

interface MembershipState {
  active: boolean;
  inactivate_at?: string;
}

/**
 * Inactivation is scheduled by setting `inactivate_at`. `active` stays true
 * until the inactivator job runs, so a passed time is not inactivated yet.
 */
export const getMembershipStatus = ({
  active,
  inactivate_at,
}: MembershipState): MembershipStatus => {
  if (!active) return 'inactive';
  if (!inactivate_at) return 'active';
  return DateTime.fromISO(inactivate_at) > DateTime.now()
    ? 'will-inactivate'
    : 'pending-inactivation';
};

export const formatScheduledInactivation = (
  formatMessage: IntlShape['formatMessage'],
  inactivateAt?: string,
) => {
  if (inactivateAt && DateTime.fromISO(inactivateAt) > DateTime.now()) {
    return formatMessage(
      { defaultMessage: 'Inaktivering schemalagd ({date})' },
      { date: formatDate(inactivateAt) },
    );
  }
  return formatMessage({ defaultMessage: 'Inaktivering schemalagd' });
};
